import { Component, OnInit, AfterViewChecked, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ColorShadeService, ColorShade } from "../../../services/color-shade.service";
import { BaseComponent } from "../../base.component";
import { PaginationService } from "app/services/pagination.service";
import { NotificationsService } from "angular2-notifications";

@Component({
	selector: 'app-color-shade',
	templateUrl: './color-shade.component.html',
	styleUrls: ['./color-shade.component.css']
})
export class ColorShadeComponent extends BaseComponent implements OnInit {

	colorShades: any[];
	colorShade: ColorShade;
	cur_colorShade: ColorShade;

	formTitle: string;
	buttonTitle: string;

	pager: any = {};
	pagedItems: any[];

	colForm: NgForm;
	@ViewChild('colForm') currentForm: NgForm;

	constructor(
		private colorShadeService: ColorShadeService,
		private paginationService: PaginationService,
		private notificationsService: NotificationsService,
	) {
		super();
	}

	ngOnInit() {
		this.colorShadeService.getColorShades().subscribe((colorShades) => {
			this.colorShades = colorShades.sort((a,b)=> {
				if(a.name == b.name)
				{
					return 0;
				}
				return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
			})
			this.setPage(1);
		});
		this.colorShade = new ColorShade();
	}
	setPage(page: number) {
		// get pager object from service
		this.pager = this.paginationService.getPager(this.colorShades.length, page);

		// get current page of items
		this.pagedItems = this.colorShades.slice(this.pager.startIndex, this.pager.endIndex + 1);
	}

	clickEdit(colorShade) {
		this.formTitle = 'Edit Color Shade';
		this.buttonTitle = 'Update Color Shade';
		this.cur_colorShade = colorShade;
		this.colorShade = Object.assign(new ColorShade(), colorShade);
	}

	clickAdd() {
		this.formErrors.name = '';
		this.formTitle = 'Add New Color Shade';
		this.buttonTitle = 'Save Color Shade';
		this.colorShade = new ColorShade();
		this.cur_colorShade = null;
	}

	onDeleteClick(key) {
		var self = this;
		if (confirm('Are you sure?')) {
			this.colorShadeService.deleteColorShade(key).then(function(){
				self.notificationsService.error('Deleted', '1 color shade deleted')
			}).catch(function(e){
				console.log(e.message);
			})
		}
	}

	formAction() {
		var form_element = <HTMLFormElement>document.getElementById("form");
		var self = this;
		if (this.colorShade) {
			if(this.formValidation(false))
			{
				if (!this.cur_colorShade) 
				{
					this.colorShadeService.addColorShade(this.colorShade).then(function(){
						self.notificationsService.success('Added','1 color shade added');
						form_element.reset();
					}).catch(function(e){
						console.log(e.message)
					});
				}
				else {
					this.colorShadeService.updateColorShade(this.cur_colorShade.$key, this.colorShade).then(function(){
						self.notificationsService.success('Updated','1 color shade updated');
						form_element.reset();
					}).catch(function(e){
						console.log(e.message)
					});
				}
			}
		}
	}

	ngAfterViewChecked() {
		this.formChanged();
	}

	formChanged() {
		if (this.currentForm === this.colForm) { return; }

		this.colForm = this.currentForm;
		if (this.colForm) {
			this.colForm.valueChanges
				.subscribe(data => {
					this.formValidation(true)
				});
		}
	}

	formValidation(checkDirty = true) {
		const form = this.colForm.form;
		for (const field in form.controls) {
			const control = form.get(field)
			if (control) {
				if (checkDirty && !control.dirty) {
					continue;
				}
				this.formErrors[field] = '';
				if (!control.valid) {
					const messages = this.validationMessages[field] || {};
					for (const key in control.errors) {
						this.formErrors[field] += messages[key] + ' ';
					}
				}
			}
		}
		return form.valid;
	}

	formErrors = {
		'name' : ''
	};

	validationMessages = {
		'name': {
			'required': 'This field is required.',
		}
	};

}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/components/color-shade/color-shade/color-shade.component.ts